import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import { FormGroupLabel } from '../common/FormGroupLabel';
import classNames from 'classnames';
import { isEmpty } from 'ac-share';
const TextArea = ({ id, name, label, value, valid, feedback, required, disabled, onChange, placeholder, className, classNameTextarea, maxRows, isAutoFocus, helpText, feedbackClassName, isShowRequired, isOffMaxHeight, }) => {
    const css = classNames('ac-input', 'custom-scroll', 'ac-textarea', isOffMaxHeight ? 'off-max-height' : '', classNameTextarea);
    return (React.createElement(FormGroupLabel, { label: label, valid: valid, feedback: feedback, className: className, isShowRequired: !isEmpty(isShowRequired) ? isShowRequired : required, helpText: helpText, feedbackClassName: feedbackClassName },
        React.createElement("div", { className: 'ac-textarea-wrapper' },
            React.createElement(TextareaAutosize, { id: id, name: name, autoFocus: isAutoFocus, value: value || '', className: css, required: required, maxRows: isEmpty(maxRows) ? 8 : maxRows, disabled: disabled, onChange: (evt) => {
                    onChange(evt.target.value);
                }, placeholder: placeholder }),
            React.createElement("div", { className: 'icon-resize' }))));
};
export { TextArea };
//# sourceMappingURL=TextArea.js.map